<template>
  <div class="button-group">
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
defineOptions({
  name: 'n-button-group',
});
</script>

<style lang="scss" scoped>
.button-group {
  display: flex;
  :deep(.btn) {
    &:not(:last-child) {
      margin-right: 0.5rem;
    }
  }
}
</style>
